import React, { useEffect, useState } from "react";
import DataTable from "react-data-table-component";
import { useForm, Controller } from "react-hook-form";
import { get, post } from "../../services/api";
import Select from "react-select";
import { toast } from "react-toastify";
import { customTableStyles } from "../../assets/CustomTableStyles";
import ReactQuill from "react-quill";
import "react-quill/dist/quill.snow.css";

function NotificationForm() {
  const token = localStorage.getItem("token");
  const organizationId = localStorage.getItem("organizationId");
  const savedCenterId =
    localStorage.getItem("centerId") === "null"
      ? null
      : localStorage.getItem("centerId");

  const [userData, setUserData] = useState([]);
  const [selectedCenterIds, setSelectedCenterIds] = useState(
    savedCenterId || null
  );
  const [selectedUserIds, setSelectedUserIds] = useState([]);
  const [centersData, setCentersData] = useState([]);
  const [notificationTypeData, setNotificationTypeData] = useState([]);
  const [notificationSourceData, setNotificationSourceData] = useState([]);
  const [roleData, setRoleData] = useState([]);
  const [attachmentFileName, setAttachmentFileName] = useState("");
  const userId = localStorage.getItem("userId");

  const {
    formState: { errors, isSubmitting },
    control,
    handleSubmit,
    setValue,
    trigger,
    register,
    getValues,
  } = useForm({
    defaultValues: {
      centerId: "",
      title: "",
      notificationMessage: "",
      datetime: "",
      AttachmentName: "",
    },
  });
  const modules = {
    toolbar: [
      ["bold", "italic", "underline", "strike"],
      ["blockquote", "code-block"],
      [{ header: 1 }, { header: 2 }],
      [{ list: "ordered" }, { list: "bullet" }],
      [{ script: "sub" }, { script: "super" }],
      [{ indent: "-1" }, { indent: "+1" }],
      [{ direction: "rtl" }],
      [{ size: ["small", false, "large", "huge"] }],
      [{ header: [1, 2, 3, 4, 5, 6, false] }],
      [{ color: [] }, { background: [] }],
      [{ font: [] }],
      [{ align: [] }],
      ["clean"],
    ],
  };
  useEffect(() => {
    const fetchCenters = async () => {
      try {
        const response = await get(
          `Dropdown/GetAllCentersByOrganizationId?organizationId=${organizationId}`,
          {
            headers: {
              Authorization: `Bearer ${token}`,
            },
          }
        );
        setCentersData(response);
        if (savedCenterId) {
          const selectedCenter = response.find(
            (center) => center.id === parseInt(savedCenterId, 10)
          );
          if (selectedCenter) {
            setValue("centerId", {
              value: selectedCenter.id,
              label: selectedCenter.name,
            });
            getAllUserList(selectedCenter.id);
          }
        }
      } catch (error) {
        console.error("Error fetching centers:", error);
      }
    };

    fetchCenters();
    fetchNotificationType();
    fetchNotificationSource();
    fetchNotificationReceiverType();
  }, [setValue, savedCenterId]);

  const fetchNotificationType = async () => {
    try {
      const response = await get(
        `CommonSettings/GetCommonSettingDetailByModuleName?moduleName=notificationType`,
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );
      setNotificationTypeData(response.commonSettingDetail);
    } catch (error) {
      console.error("Error fetching notificationType:", error);
    }
  };

  const fetchNotificationSource = async () => {
    try {
      const response = await get(
        `CommonSettings/GetCommonSettingDetailByModuleName?moduleName=notificationSource`,
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );
      setNotificationSourceData(response.commonSettingDetail);
    } catch (error) {
      console.error("Error fetching notificationSource:", error);
    }
  };

  const fetchNotificationReceiverType = async () => {
    try {
      const response = await get(`Role`, {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      });
      setRoleData(response);
    } catch (error) {
      console.error("Error fetching roles:", error);
    }
  };

  const getAllUserList = async (centerId) => {
    if (!token) {
      console.error("Unauthorized.");
      return;
    }
    let roleId = getValues("roleId")?.value || 0;
    try {
      const response = await get(
        `User/GetUsersForNotification?centerId=${centerId}&roleId=${roleId}`,
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );
      setUserData(response);
    } catch (error) {
      console.error("Error fetching users:", error);
    }
  };

  const columns = [
    { name: "Sr No.", selector: (row, rowIndex) => rowIndex + 1 },
    { name: "Id", selector: (row) => row.id, sortable: true, omit: true },
    { name: "Name", selector: (row) => row.userName, sortable: true },
    { name: "User Type", selector: (row) => row.role, sortable: true },
    { name: "Email", selector: (row) => row.email, sortable: true },
    {
      name: "Mobile Number",
      selector: (row) => row.mobileNumber,
      sortable: true,
    },
  ];

  const handleRowSelected = (state) => {
    const selectedRows = state.selectedRows.map((row) => row.id);
    setSelectedUserIds((prevSelectedIds) => {
      const allSelectedIds = new Set([...prevSelectedIds, ...selectedRows]);
      return Array.from(allSelectedIds);
    });
  };

  const saveData = async (data) => {
    if (!token) {
      console.error("Unauthorized.");
      return;
    }

    if (selectedUserIds.length === 0) {
      alert("Please select at least one user.");
      return;
    }

    const formData = {
      notificationSourceId: data.notificationSourceId.value,
      notificationMessage: data.notificationMessage,
      notificationTypeId: data.notificationTypeId.value,
      title: data.title,
      userIds: selectedUserIds,
      attachmentName: attachmentFileName || "",
      base64String: getValues("base64String"),
      createdBy: userId,
      centerId: savedCenterId,
    };

    try {
      const response = await post("User/SendAlertNotification", formData, {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      });
      if (response.isSuccess) {
        toast.success("Success!");
        getAllUserList(selectedCenterIds);
      }
    } catch (error) {
      console.error("Error sending notification:", error);
    }
  };

  const handleFileChange = (event) => {
    const file = event.target.files[0];
    if (file) {
      setAttachmentFileName(file.name);
      const reader = new FileReader();
      reader.onloadend = () => {
        const base64String = reader.result.split(",")[1];
        setValue("base64String", base64String, { shouldValidate: true });
        //trigger("AttachmentName");
      };
      reader.readAsDataURL(file);
    }
  };

  return (
    <>
      <div className="page-header d-flex mb-2">
        <h2 className="page-heading fs-7">Notification Form</h2>
      </div>

      <form className="row g-3" onSubmit={handleSubmit(saveData)}>
        <div className="col-md-6">
          <div className="card">
            <div className="card-body">
              <div className="row gy-3 gx-2">
                <div className="col-md-4">
                  <label className="form-label">
                    Center<span className="text-danger fs-9">*</span>
                  </label>
                  <Controller
                    name="centerId"
                    control={control}
                    rules={{ required: "This field is required." }}
                    render={({ field }) => (
                      <Select
                        {...field}
                        options={centersData.map((center) => ({
                          value: center.id,
                          label: center.name,
                        }))}
                        onChange={(selectedOption, actionMeta) => {
                          if (actionMeta.action === "clear") {
                            setValue(`centerId`, null);
                          } else {
                            setValue(
                              `centerId`,
                              selectedOption || { value: 0, label: "" }
                            );
                            getAllUserList(selectedOption.value);
                          }
                          trigger(`centerId`);
                        }}
                        className="react-select-style"
                        classNamePrefix="react-select-style-pref"
                      />
                    )}
                  />
                  {errors.centerId && (
                    <small className="text-danger">
                      {errors.centerId.message}
                    </small>
                  )}
                </div>
                <div className="col-md-8"></div>
                <div className="col-md-4">
                  <label className="form-label">Receiver</label>
                  <Controller
                    name="roleId"
                    control={control}
                    render={({ field }) => (
                      <Select
                        {...field}
                        options={roleData.map((role) => ({
                          value: role.id,
                          label: role.name,
                        }))}
                        onChange={(selectedOption, actionMeta) => {
                          if (actionMeta.action === "clear") {
                            setValue(`roleId`, null);
                          } else {
                            setValue(
                              `roleId`,
                              selectedOption || { value: 0, label: "" }
                            );
                            getAllUserList(getValues("centerId").value);
                          }
                          trigger(`roleId`);
                        }}
                        className="react-select-style"
                        classNamePrefix="react-select-style-pref"
                      />
                    )}
                  />
                </div>

                <div className="col-md-4">
                  <label className="form-label">
                    Source<span className="text-danger fs-9">*</span>
                  </label>
                  <Controller
                    name="notificationSourceId"
                    control={control}
                    rules={{ required: "This field is required." }}
                    render={({ field }) => (
                      <Select
                        {...field}
                        options={notificationSourceData.map((source) => ({
                          value: source.id,
                          label: source.key,
                        }))}
                        onChange={(selectedOption, actionMeta) => {
                          if (actionMeta.action === "clear") {
                            setValue(`notificationSourceId`, null);
                          } else {
                            setValue(
                              `notificationSourceId`,
                              selectedOption || { value: 0, label: "" }
                            );
                          }
                          trigger(`notificationSourceId`);
                        }}
                        className="react-select-style"
                        classNamePrefix="react-select-style-pref"
                      />
                    )}
                  />
                  {errors.notificationSourceId && (
                    <small className="text-danger">
                      {errors.notificationSourceId.message}
                    </small>
                  )}
                </div>

                <div className="col-md-4">
                  <label className="form-label">
                    Type<span className="text-danger fs-9">*</span>
                  </label>
                  <Controller
                    name="notificationTypeId"
                    control={control}
                    rules={{ required: "This field is required." }}
                    render={({ field }) => (
                      <Select
                        {...field}
                        options={notificationTypeData.map((notification) => ({
                          value: notification.id,
                          label: notification.key,
                        }))}
                        onChange={(selectedOption, actionMeta) => {
                          if (actionMeta.action === "clear") {
                            setValue(`notificationTypeId`, null);
                          } else {
                            setValue(
                              `notificationTypeId`,
                              selectedOption || { value: 0, label: "" }
                            );
                          }
                          trigger(`notificationTypeId`);
                        }}
                        className="react-select-style"
                        classNamePrefix="react-select-style-pref"
                      />
                    )}
                  />
                  {errors.notificationTypeId && (
                    <small className="text-danger">
                      {errors.notificationTypeId.message}
                    </small>
                  )}
                </div>

                <div className="col-md-4">
                  <label className="form-label">
                    Subjet<span className="text-danger fs-9">*</span>
                  </label>
                  <input
                    {...register(`title`, {
                      required: "This field is required.",
                    })}
                    type="text"
                    className="form-control"
                  />
                  {errors.title && (
                    <small className="text-danger">
                      {errors.title.message}
                    </small>
                  )}
                </div>
                {getValues("notificationSourceId")?.label === "Email" ? (
                  <div className="col-md-4">
                    <label className="form-label">Attachment</label>
                    <input
                      // {...register('attachmentName', { required: 'Attachment is required' })}
                      type="file"
                      className="form-control"
                      onChange={handleFileChange}
                    />
                    {/* {errors.attachmentName && (
                    <small className="text-danger">{errors.attachmentName.message}</small>
                  )} */}
                  </div>
                ) : (
                  ""
                )}

                {/* <div className="col-md-4">
                  <label className="form-label">
                    DateTime<span className="text-danger fs-9">*</span>
                  </label>
                  <input
                    {...register(`datetime`, { required: "This field is required." })}
                    type="datetime-local"
                    className="form-control"
                  />
                  {errors.datetime && (
                    <small className="text-danger">{errors.datetime.message}</small>
                  )}
                </div> */}

                <div className="col-md-12">
                  <label className="form-label">
                    {getValues("notificationSourceId")?.label === "Email"
                      ? "Email Template"
                      : "Message"}
                    <span className="text-danger fs-9">*</span>
                  </label>
                  <Controller
                    name="notificationMessage"
                    control={control}
                    rules={{ required: "This field is required." }}
                    render={({ field }) =>
                      getValues("notificationSourceId")?.label === "Email" ? (
                        <ReactQuill
                          theme="snow"
                          modules={modules}
                          value={field.value}
                          onChange={field.onChange}
                          className="bg-white"
                        />
                      ) : (
                        <textarea
                          {...field}
                          className="form-control"
                          rows="5"
                        />
                      )
                    }
                  />
                  {errors.notificationMessage && (
                    <small className="text-danger">
                      {errors.notificationMessage.message}
                    </small>
                  )}
                </div>

                <div className="col-md-12 mt-3">
                  <button
                    className="btn btn-primary btn-sm"
                    type="submit"
                    disabled={isSubmitting}
                  >
                    {isSubmitting ? "Saving..." : "Save"}
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div className="col-md-6">
          <div className="card">
            <div className="card-body">
              <div className="row">
                <div className="col-md-12">
                  <label className="form-label">
                    Users<span className="text-danger fs-9">*</span>
                  </label>
                  <DataTable
                    columns={columns}
                    data={userData}
                    pagination
                    dense
                    customStyles={customTableStyles}
                    highlightOnHover={true}
                    pointerOnHover={true}
                    selectableRows
                    onSelectedRowsChange={handleRowSelected}
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
      </form>
    </>
  );
}

export default NotificationForm;
